import angular from 'angular';
import { default as orgDataService } from 'app/services/data/org.data.service';
import { default as userService } from 'app/services/membership/ss.user.service';
import controller from './switch-banks-dialog.controller';
import template from './switch-banks-dialog.html';

const library = require('@safe-systems/ss-ui-components');

const {
  alerts,
  authorizationService,
  loaderService,
  ssDialogService,
} = library;

class dialogService {
  getOptions($event, { assignedBanks }) {
    return {
      controller,
      controllerAs: 'switchBanksDialogVM',
      locals: {
        assignedBanks
      },
      targetEvent: $event,
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      template,
    };
  }
}

export default angular.module('app.components.global.userBar.switchBanksDialog', [
  alerts,
  ssDialogService,
  loaderService,
  orgDataService,
  userService,
  authorizationService
])
  .service('switchBanksDialog', dialogService)
  .name;
